<template>
	<div class="multi-select-main-container">
		<div class="checkbox-container">
			<CheckboxGroup v-model="checked">
				<template v-for="item in doctorsByClinic" :key="item.uid">
					<div v-if="item.type === 'clinic'" class="clinic">{{ item.name }}</div>
					<Checkbox v-else :name="item.uid" class="doctor">
						{{ item.name }}
						<Icon v-if="!item.autoGroup" name="warn-o" title="Отключена автозапись" color="#bb0000" />
					</Checkbox>
				</template>
			</CheckboxGroup>
		</div>
		<div class="pd">
			<Button round block type="primary" @click="onClickInner">
				Готово
			</Button>
		</div>
	</div>
</template>

<script>
import { ref } from 'vue';
import { CheckboxGroup, Checkbox, Button, Icon } from 'vant';
import { findByProp } from './utils';

export default {
	components: {
		CheckboxGroup, Checkbox, Button, Icon,
	},
	props: {
		items: {
			type: Array,
			required: true,
		},
		onClick: Function,
		initialChecked: {
			type: Array,
			default() {
				return [];
			}
		},
	},
	watch: {
		items: function () {
			this.checked = [];
		}
	},
	data() {
		return {
			checked: this.initialChecked,
		}
	},
	computed: {
		doctorsByClinic() {
			let result = [];
			let prevClinicUid = '';
			for (let doctor of this.items) {
				if (doctor.clinicUid != prevClinicUid) {
					result.push({ name: doctor.clinic.title, type: 'clinic'});
					prevClinicUid = doctor.clinicUid;
				}
				result.push({ ...doctor, type: 'doctor'});
			}
			return result;
		},
	},
	methods: {
		onClickInner() {
			let result = [];
			for (let checkedUid of this.checked) {
				result.push(findByProp(this.items, 'uid', checkedUid));
			}
			this.onClick(result);
		}
	}
}
</script>

<style scoped>
.checkbox-container {
	max-height: 50vh;
	overflow: auto;
}
.clinic {
	font-size: 0.7em;
	color: #444;
	margin: 24px var(--van-padding-md) var(--van-padding-md);
}
.clinic:first-child {
	margin-top: var(--van-padding-md);
}
.doctor {
	margin: 0 var(--van-padding-md) var(--van-padding-md);
}
</style>
